import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CacheService<T> {
    constructor() {
    }

    public saveData(newData: T, key: string, expirationTimeInMinutes: number | null = null) {
        localStorage.setItem(key, JSON.stringify({
            entity: newData,
            expirationTime: expirationTimeInMinutes ? new Date().getTime() + expirationTimeInMinutes * 60 * 1000 : undefined,
        }));
    }

    public getData(key: string): T | undefined {
        const storedData = localStorage.getItem(key);
        const parsedData: {
            entity: T,
            expirationTime: number | undefined
        } = storedData ? JSON.parse(storedData) : null;
        if (parsedData && parsedData.expirationTime && new Date().getTime() > parsedData.expirationTime) {
            this.removeData(key);
            return undefined;
        }

        return parsedData?.entity;
    }

    public removeData(key: string) {
        localStorage.removeItem(key);
    }
}
